import computeClassName from '../../../../../../../../../../utils/computeClassName';
import handleClick from '../../../../../../../../../../utils/handleClick';
import useToggle from '../../../../../../../../../../hooks/ui/useToggle';
import PartnerTile from '../../../Tile';
import CCIconMinus20x20 from '../../../../../../../../../libs/CiscoCore/Icon/Minus/20x20';
import CCIconPlus20x20 from '../../../../../../../../../libs/CiscoCore/Icon/Plus/20x20';

export default function SavedPartnersSection(
  {
    sectionTitle,
    sectionPartnerRole,
    selectedPartnerRoleCode,
    savedPartners,
    isComparatorToBeShown,
    comparedItemList,
    comparedItemCategory,
    clearComparatorText,
    clearComparatorClickFn,
    noSavedPartnersText,
    className = ''
  }) {
  const computedClassName = computeClassName(className, '');
  const { toggle, isToggleOn } = useToggle(selectedPartnerRoleCode === sectionPartnerRole);
  const toggleClickFn = handleClick(toggle);

  return (
    <section className={computedClassName} aria-expanded={isToggleOn()}>
      <header className="flex flex-row items-center justify-between py-2 mb-4 cursor-pointer" onClick={toggleClickFn}>
        <h3 className="flex-grow flex-shrink"><span className="font-semibold">{sectionTitle}</span><span className="ml-cc-1char text-cc-accent">({savedPartners.length})</span></h3>
        {
          isToggleOn() ? <CCIconMinus20x20 className="text-cc-muted-contrast"/> : <CCIconPlus20x20 className="text-cc-muted-contrast"/>
        }
      </header>
      {
        isToggleOn() &&
        <div className="max-w-full overflow-x-auto 3xs:overflow-visible pb-4">
          <ul className="list-none flex flex-row space-x-6 3xs:space-x-0 3xs:grid 3xs:grid-cols-2 xs:grid-cols-3 md:grid-cols-4 3xs:gap-6 mb-4">
            {
              savedPartners.map(
                (savedPartner, index) => {
                  return (
                    <li key={index} className="flex-shrink-0 w-cc-55 3xs:w-auto">
                      <PartnerTile partner={savedPartner}
                                   selectedPartnerRoleCode={sectionPartnerRole}
                                   isComparatorToBeShown={isComparatorToBeShown}/>
                    </li>
                  )
                }
              )
            }
          </ul>
          {
            (savedPartners.length === 0) &&
            <p>{noSavedPartnersText}</p>
          }
          {
            (isComparatorToBeShown) && (!!savedPartners.length) && (comparedItemCategory === sectionPartnerRole) && (!!comparedItemList.length) &&
            <p className="mt-4"><a href="/" onClick={clearComparatorClickFn} className="text-cc-link text-cc-body-medium">{clearComparatorText}</a></p>
          }
        </div>
      }
    </section>
  );
}
